import { render, staticRenderFns } from "./ContactoPacienteV5.vue?vue&type=template&id=1af3d0e6&scoped=true"
import script from "./ContactoPacienteV5.vue?vue&type=script&lang=js"
export * from "./ContactoPacienteV5.vue?vue&type=script&lang=js"
import style0 from "./ContactoPacienteV5.vue?vue&type=style&index=0&id=1af3d0e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af3d0e6",
  null
  
)

export default component.exports